<template>
    <div class="accordion" :class="{ 'level-1': !isChild, 'level-2': isChild }">
        <div
            :class="{ 'is-active': show, 'justify-between': !customTitleSpacing, 'justify-start': customTitleSpacing }"
            class="title"
            @click="toggle"
        >
            <div
                :class="{ 'accordion-title-width': ! customTitleSpacing, [customTitleSpacing]: !! customTitleSpacing }"
                class="flex flex-col pr-md md:pr-0 md:flex-row"
            >
                <slot name="toggle-title" />
            </div>

            <div v-if="$slots['extra-text']" class="flex-grow text-sm text-neutral-dark font-regular">
                <slot name="extra-text" />
            </div>
            <div v-if="$slots['badge']" class="mr-xl">
                <slot name="badge" />
            </div>

            <slot v-if="! hasDefaultIcon && show" name="open-custom-icon" />
            <slot v-if="! hasDefaultIcon && ! show" name="closed-custom-icon" />

            <div
                v-if="hasDefaultIcon"
                :class="{ 'rotate': show }"
                class="ml-auto icon"
            >
                <font-awesome-icon icon="chevron-down" />
            </div>
        </div>
        <!--<transition name="expand">-->
        <div
            v-if="show"
            class="content"
            :class="{ 'is-open': show }"
        >
            <slot
                :toggle="toggle"
                name="toggle-content"
            />
        </div>
        <!--</transition>-->
    </div>
</template>

<script>
    export default {
        props: {
            isChild: {
                required: false,
                type: Boolean,
                default: false,
            },
            customTitleSpacing: {
                type: String,
                default: '',
            },
            wrapperClass: {
                required: false,
                type: String,
                default: null,
            },
            initialShow: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                show: this.initialShow,
            };
        },
        computed: {
            hasDefaultIcon() {
                return ! this.$slots['open-custom-icon'];
            },
        },
        methods: {
            toggle() {
                this.show = ! this.show;
            },
        },
    };
</script>